import { ShoppingCartProducts } from '../store/reducers/CartReducer';

export const calculateTotalNumber = (products: ShoppingCartProducts): number => {
  return Object.values(products).reduce((acc, product) => acc + product.quantity, 0);
};
